import React from "react";
import parse from "html-react-parser"

import "./optional_definitions.scss"

const OptionalDefinitions = ({sectionContent}) => {
  return (
    <div className="optional-definitions">
      <h2>Definitions</h2>
      <div>
            {parse(sectionContent)}
      </div>
    </div>
  )
}

export default OptionalDefinitions;